import type { Competition, CurrentCompetitions } from '$lib/types/leaderboard';

let competitions: Record<CurrentCompetitions, Competition> = {
	shanghai: {
		name: 'Shanghai Season',
		prize: 6900,
		prize_breakdown: {
			first: 4200,
			second: 1200,
			third: 700,
			limit_volume: 1000
		},
		description:
			'Trade for 7 days and get a chance to win part of $6,900. Top 3 and highest limit order volume traders get prizes.',
		more: 'https://mirror.xyz/0xf3897707d8Fa5dC27b2A6575319e409a464eB8D8/8ogoKKXVmmvlj8BSv30BBR0KSoQhIYI8-rwdUvZ2ti8',
		id: 'shanghai',
		startTimestamp: 1681316900,
		endTimestamp: 1681921700
	},
	cryptotesters: {
		name: 'Crypto Testers',
		prize: 2500,
		prize_breakdown: {
			first: 1500,
			second: 1000,
			third: 100,
			limit_volume: 200,
			rest_7: 100
		},
		description:
			'Cryptotesters NFT holders can participate in the competition. Top 3 and highest limit order volume traders get prizes.',
		more: 'https://discord.com/channels/811257493706768396/811257494315728908/1095985985931718737',
		id: 'cryptotesters',
		startTimestamp: 1681366277,
		endTimestamp: 1681971076
	},
	'all-time-season': {
		name: 'All time',
		prize: 0,
		prize_breakdown: {
			first: 1500,
			second: 1000,
			third: 100,
			limit_volume: 200,
			rest_7: 100
		},
		description: 'You were not supposed to see this',
		more: 'polynomial.fi',
		id: 'all-time-season',
		startTimestamp: 0,
		endTimestamp: 9999999999999,
		hide: true
	}
};
export default competitions;
